<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)">
		<div class="ld-panel-title">
			<h2 class="back-btn">白名单</h2>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" class="add" @click="dialogGroupVisible = true">添加名单</el-button>
			<div class="search-main clear">
				<el-input v-model="searchInput" class="input" placeholder="请输入搜索内容..." clearable @clear="handleEmpty"></el-input>
				<span @click="searchClick" class="btn"></span>
			</div>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column label="关联实例">
					<template #default="scope">
						{{scope.row.instance_list}}
						<el-text style="cursor: pointer;" type="warning" size="small" v-if="scope.row.extend_instance_list.length > 1" @click="instanceListF(scope.row.extend_instance_list)">查看更多></el-text>
					</template>
				</el-table-column>
				<el-table-column prop="list_name" label="名称" />
				<el-table-column prop="ip_list" label="规则" />
				<el-table-column label="是否启用">
					<template #default="scope">
						<el-switch v-show="scope.row.loading" loading v-model="scope.row.status" />
						<el-switch v-show="!scope.row.loading" @click="switchChange(scope.row,scope.$index)" v-model="scope.row.status" />
					</template>
				</el-table-column>
				<el-table-column label="操作" width="110">
				  <template #default="scope">
					<el-button link type="primary" size="small" v-if="scope.row.enabled == 2" @click="rowOperation(scope.row,'edit')">编辑</el-button>
					<el-button link type="danger" size="small" v-if="scope.row.enabled == 2" @click="rowOperation(scope.row,'delete')">删除</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- instance列表 -->
		<el-dialog width="700" :close-on-click-modal="false" v-model="dialoginstanceVisible" title="实例列表">
			<el-table :data="instanceData" max-height='600' v-loading="loading" style="width: 100%">
				<el-table-column prop="instance_id" label="实例ID" />
				<el-table-column prop="instance_name" label="实例名称" />
			</el-table>
		</el-dialog>
		<!-- 添加 -->
		<el-dialog width="1000" :show-close="false" :close-on-click-modal="false" align-center v-model="dialogGroupVisible" title="白名单">
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="名称" prop="list_name">
					<el-input v-model="groupForm.list_name" autocomplete="off" />
				</el-form-item>
				<el-form-item label="规则" prop="ip_list">
					<el-input v-model="groupForm.ip_list" type="textarea" :autosize="{ maxRows: 3}" @input="numChange" placeholder="请输入IP地址" />
					<div class="el-upload__tip">
						<p>最多20个，使用回车符分隔，不可重复，如：127.0.0.1</p>
					</div>
				</el-form-item>
				<el-form-item label="关联实例">
					<el-transfer v-model="groupForm.instance_id_list" :titles="['实例列表', '已选择实例']" :data="contactData" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm(ruleFormRef)">取消</el-button>
					<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted,nextTick } from 'vue';
	import { fetchExample } from '@/api/users';
	import { fetchList,listCreate,listDelete,listSwitch } from '@/api/list';
	import pageList from '../../components/pageList.vue'
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const fullscreenLoading = ref(false);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const searchInput = ref('');
	const listType = ref('1');
	const dialoginstanceVisible = ref(false);
	const instanceData = ref();
	const dialogGroupVisible = ref(false);
	const formLabelWidth = ref('120');
	const tableData = ref();
	const ruleFormRef = ref(null);
	const groupForm = ref({list_name:'',ip_list:'',instance_id_list:''})
	const rules = reactive({
		list_name: [
			{ required: true, message: '请填写名称', trigger: 'blur' },
		],
		ip_list: [
			{ required: true, message: '请填写规则', trigger: 'blur' },
		]
	});
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.total;
			const data = res.data.list;
			for (var i = 0; i < data.length; i++) {
				data[i].loading = false;
				if (data[i].extend_instance_list[0]) {
					data[i].instance_list = data[i].extend_instance_list[0].instance_name;
				}
				data[i].instance_id_list = data[i].extend_instance_list.map(obj => {return obj.instance_id});
			}
			tableData.value = data;
			loading.value = false;
		})
	};
	const generateData = () => {
		const param = {'page':1,'size':9999}
		const data = []
		fetchExample(param).then((res) => {
			for (let i = 0; i < res.data.list.length; i++) {
				data.push({
					key: res.data.list[i].instance_id,
					label: res.data.list[i].instance_name
				});
			}
		})
		return data
	};
	const contactData = generateData();
	
	const switchChange = (row,index) => {
		tableData.value[index].loading = true;
		if (row.enable == 1) {
			tableData.value[index].enabled = 1;
		}
		const param = {'list_id':row.list_id,'enabled':row.status}
		listSwitch(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
			}
			fetchListF()
		})
	}
	const wayChange = (val) =>{
		listType.value = val;
	}
	const instanceListF = (row) => {
		dialoginstanceVisible.value = !dialoginstanceVisible.value;
		instanceData.value = row;
	}
	const numChange = (val) => {
		const str = val.replace(/\r\n/g, '\n');
		if(str.split('\n').length >= 20){
			ElMessage({
				offset:70,
				message: '规则最多添加20个',
				type: 'error'
			})
		}
	}
	const rowOperation = (row, now) => {
		if(now == 'edit'){
			dialogGroupVisible.value = !dialogGroupVisible.value;
			nextTick(() => {
			    Object.assign(groupForm.value,row);
				groupForm.value.ip_list = row.ip_list.split(";").join("\n");
				listType.value = row.list_type.toString()
			})
		}
		if(now == 'delete'){
			const param = {"list_id": row.list_id}
			ElMessageBox.confirm(
				'确定要删除该记录吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				listDelete(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	};
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			fullscreenLoading.value = true;
			groupForm.value.list_type = parseInt(listType.value);
			const param = groupForm.value;
			listCreate(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					resetForm()
					fetchListF();
				}
				fullscreenLoading.value = false;
			})
	    } else {
	      return false;
	    }
	  });
	};
	const resetForm = () => {
		groupForm.value = {list_name:'',ip_list:'',instance_id_list:''};
		ruleFormRef.value.resetFields();
		dialogGroupVisible.value = !dialogGroupVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const searchClick = () => {
		fetchListF()
	};
	const handleEmpty = () => {
		fetchListF()
	};
	
	onMounted(() => {
		fetchListF();
	})
	
	
</script>

<style lang="scss" scoped>
	.search-main{float: right;}
	.type{
		.text{color: #888;margin-left: 10px;}
		.el-input{width: 50% !important;}
	}
</style>